const retrievalProof = {
  routes: [
    {
      path: '/retrievalProof/list',
      name: 'retrievalProofList',
      meta: {
        isShowHeader: true,
        isShowLeftSider: true,
        // keepAlive: true,
        breadcrumb: [
          {
            name: '首页',
            path: '/index'
          },
          {
            name: '检索证明',
            path: '/retrievalProof/list'
          }
        ]
      },
      component: () => import('@/project/views/retrieval-proof/list')
    },
    {
      path: '/retrievalProof/create',
      name: 'retrievalProofCreate',
      meta: {
        isShowHeader: true,
        // isShowLeftSider: true,
        // keepAlive: true,
        breadcrumb: [
          {
            name: '首页',
            path: '/index'
          },
          {
            name: '新建检索证明',
            path: '/retrievalProof/list'
          }
        ]
      },
      component: () => import('@/project/views/retrieval-proof/create')
    },
    {
      path: '/retrievalProof/show/:id',
      name: 'retrievalProofShow',
      meta: {
        isShowHeader: true,
        // isShowLeftSider: true,
        // keepAlive: true,
        breadcrumb: [
          {
            name: '首页',
            path: '/index'
          },
          {
            name: '检索证明',
            path: '/retrievalProof/list'
          }
        ]
      },
      component: () => import('@/project/views/retrieval-proof/show')
    },
    {
      path: '/retrievalProof/edit/:id',
      name: 'retrievalProofEdit',
      meta: {
        isShowHeader: true,
        breadcrumb: [
          {
            name: '首页',
            path: '/index'
          },
          {
            name: '检索证明',
            path: '/retrievalProof/list'
          }
        ]
      },
      component: () => import('@/project/views/retrieval-proof/edit')
    },
    {
      path: '/retrievalProof/reedit/:id',
      name: 'retrievalProofReedit',
      meta: {
        isShowHeader: true,
        breadcrumb: [
          {
            name: '首页',
            path: '/index'
          },
          {
            name: '检索证明',
            path: '/retrievalProof/list'
          }
        ]
      },
      component: () => import('@/project/views/retrieval-proof/reedit')
    },
  ]
}
export default retrievalProof



// WEBPACK FOOTER //
// ./src/project/router/retrieval-proof.js